import React, { useState } from "react";
import { GraduationCap } from "lucide-react";
import { education, leadership, companyLogos } from "../mock";

const VoxPopuliLogo = () => {
  const [failed, setFailed] = useState(false);
  const cfg = companyLogos["Vox Populi"];

  if (!cfg || failed) {
    return (
      <div
        className="w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0"
        style={{ background: "rgba(245,158,11,0.1)", border: "1px solid rgba(245,158,11,0.3)" }}
      >
        <span className="text-sm font-bold text-[#F59E0B]">VP</span>
      </div>
    );
  }

  return (
    <div
      className="w-12 h-12 rounded-xl overflow-hidden flex items-center justify-center flex-shrink-0"
      style={{ background: cfg.bg, border: "1px solid rgba(245,158,11,0.3)", padding: cfg.padding }}
    >
      <img
        src={cfg.url}
        alt="Vox Populi"
        className="w-full h-full object-contain"
        onError={() => setFailed(true)}
      />
    </div>
  );
};

const EducationSection = () => {
  return (
    <section id="education" className="py-16 md:py-24" style={{ background: "#09090B" }}>
      <div className="max-w-6xl mx-auto px-5 sm:px-6">
        {/* Section header */}
        <div className="mb-14">
          <p className="text-xs font-semibold uppercase tracking-widest text-[#06B6D4] mb-3">Background</p>
          <h2 className="text-3xl md:text-4xl font-bold text-white">Education & Leadership</h2>
          <p className="text-[#71717A] mt-3 max-w-lg">
            A strong analytical foundation from IIT Kanpur, paired with real-world editorial leadership.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {/* Education */}
          {education.map((edu) => (
            <div
              key={edu.id}
              className="p-6 rounded-xl border hover:border-[#06B6D4]/30 transition-all duration-300"
              style={{ background: "#0F0F11", border: "1px solid #1E1E24" }}
            >
              <div className="flex items-start gap-4">
                <div
                  className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0"
                  style={{ background: "rgba(6,182,212,0.1)", border: "1px solid rgba(6,182,212,0.3)" }}
                >
                  <GraduationCap className="w-5 h-5 text-[#06B6D4]" />
                </div>
                <div>
                  <h3 className="text-white font-semibold text-base">{edu.institution}</h3>
                  <p className="text-[#06B6D4] text-sm font-medium mt-0.5">{edu.degree}</p>
                  <div className="flex items-center gap-3 mt-2">
                    <span className="text-xs text-[#71717A]">{edu.period}</span>
                    <span
                      className="px-2 py-0.5 rounded text-xs font-semibold"
                      style={{ background: "rgba(16,185,129,0.1)", color: "#10B981", border: "1px solid rgba(16,185,129,0.2)" }}
                    >
                      {edu.grade}
                    </span>
                  </div>
                  <p className="text-[#71717A] text-sm mt-3 leading-relaxed">{edu.description}</p>
                </div>
              </div>
            </div>
          ))}

          {/* Leadership */}
          {leadership.map((item) => (
            <div
              key={item.id}
              className="p-6 rounded-xl border hover:border-[#F59E0B]/30 transition-all duration-300"
              style={{ background: "#0F0F11", border: "1px solid #1E1E24" }}
            >
              <div className="flex items-start gap-4">
                <VoxPopuliLogo />
                <div className="flex-1">
                  <h3 className="text-white font-semibold text-base">{item.organization}</h3>
                  <p className="font-medium text-sm mt-0.5" style={{ color: "#F59E0B" }}>{item.role}</p>
                  <span className="text-xs text-[#71717A] mt-1 block">{item.period}</span>
                  <ul className="mt-4 space-y-2">
                    {item.bullets.map((b, i) => (
                      <li key={i} className="flex items-start gap-2 text-sm text-[#A1A1AA]">
                        <span className="flex-shrink-0 w-1 h-1 rounded-full mt-2" style={{ background: "#F59E0B" }} />
                        {b}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Quick stat strip */}
        <div
          className="mt-10 p-5 rounded-xl border grid grid-cols-2 md:grid-cols-4 gap-6"
          style={{ background: "#0F0F11", border: "1px solid #1E1E24" }}
        >
          {[
            { label: "Years of Experience", value: "5+" },
            { label: "Revenue Scaled", value: "14x" },
            { label: "Data Insights Unlocked", value: "100+" },
            { label: "Wore All Hats", value: "∞" }
          ].map((stat, i) => (
            <div key={i} className="text-center">
              <p className="text-2xl font-bold text-[#06B6D4]">{stat.value}</p>
              <p className="text-xs text-[#71717A] mt-1">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default EducationSection;
